import React, { useEffect } from "react";
import { Form, Row } from "antd";
import ReactGA from "react-ga4";
import { getIconUrl } from "../../../../../../services/asset";
import styles from "./style.scss";
import SearchGroups from "./SearchGroups";
import QuickSearches from "../../../../QuickSearches/QuickSearches";
import { saveSearch } from "../../../../../../routes/Search/search.ducks";
import { submitFormData } from "../../../../../../HOCs";

const SearchControls = (props: any) => {
  const {
    closeAllSearch,
    form,
    groups,
    numberOfControls,
    onSubmit,
    renderSearchBtn,
    resetFormFields,
    showAllControls,
    setShowAllControls,
    resetFields,
    categoryHr
  } = props;

  if (!groups) {
    return null;
  }

  useEffect(() => {
    const { form } = props;
    const values = form.getFieldsValue();
    props.onValuesChange(values);
  }, []);

  const handleResetFields = () => {
    const { form } = props;
    form.resetFields();
    resetFormFields();
    resetFields();
    ReactGA.event({
      category: "Pretraga",
      action: "Click",
      label: "Resetiranje filtera - naslovnica"
    });
  };

  return (
    <div>
      <div
        className={showAllControls ? styles.formWrapperAll : styles.formWrapper}
      >
        <Form>
          <Row type="flex" justify="center">
            <SearchGroups
              onSubmit={onSubmit}
              onReset={handleResetFields}
              form={form}
              groupConfigs={groups}
              numberOfControls={numberOfControls}
              showAllControls={showAllControls}
              setShowAllControls={setShowAllControls}
              closeAllSearch={closeAllSearch}
            />
          </Row>
        </Form>
        <div className={`${styles.quickSearchesWrapper} ${showAllControls ? styles.quickSearchesAll : ""}`}>
          <QuickSearches categoryHr={categoryHr} />
        </div>
      </div>
      {showAllControls && (
        <div className={styles.buttonsSection}>
          <div className={styles.actions}>
            <span onClick={handleResetFields} className={styles.imageWrapper}>
              <img
                alt={"Osvježi sada"}
                src={getIconUrl("reload.svg")}
              />
            </span>
            {renderSearchBtn(onSubmit)}
          </div>
        </div>
      )}
    </div>
  );
};

export default submitFormData(
  Form.create({
    // @ts-ignore
    onValuesChange: (props, _, allValues) => {
      const { onValuesChange } = props;
      onValuesChange(allValues);
    }
  })(SearchControls),
  saveSearch
);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/SearchControls/index.tsx